import React from 'react';
import { Home, Compass, Gift, User, ScanLine } from 'lucide-react';
import { ScreenName } from '../types';
interface BottomNavProps {
  currentScreen: ScreenName;
  onNavigate: (screen: ScreenName) => void;
}
export function BottomNav({
  currentScreen,
  onNavigate
}: BottomNavProps) {
  const leftTabs = [{
    id: 'home',
    icon: Home,
    label: 'Home'
  }, {
    id: 'explore',
    icon: Compass,
    label: 'Explore'
  }];
  const rightTabs = [{
    id: 'gifting',
    icon: Gift,
    label: 'Gifts'
  }, {
    id: 'profile',
    icon: User,
    label: 'Profile'
  }];
  // Determine active tab (handle nested screens)
  const getActiveTab = (screen: ScreenName) => {
    if (screen === 'storeProfile' || screen === 'menu' || screen === 'checkout' || screen === 'checkInSuccess') return 'explore';
    if (screen === 'giftRedeem' || screen === 'giftHistory') return 'gifting';
    if (screen === 'orders' || screen === 'orderDetails') return 'profile';
    return screen;
  };
  const activeTab = getActiveTab(currentScreen);
  return <div className="fixed bottom-0 left-0 right-0 bg-black rounded-t-3xl shadow-lg px-2 py-2 flex justify-between items-end max-w-md mx-auto z-50" data-id="element-30">
      {/* Left Tabs */}
      <div className="flex justify-around flex-1" data-id="element-31">
        {leftTabs.map(tab => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => onNavigate(tab.id as ScreenName)} className={`flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-all ${isActive ? 'bg-[#FFFC00] text-black' : 'text-white'}`} data-id="element-32">
              <Icon size={20} className={isActive ? 'text-black' : 'text-white'} data-id="element-33" />
              <span className="text-xs mt-1 font-medium" data-id="element-34">{tab.label}</span>
            </button>;
      })}
      </div>

      {/* Center Scan Button */}
      <div className="relative -top-5 px-1" data-id="element-35">
        <button onClick={() => onNavigate('scan')} className="w-14 h-14 bg-[#FFFC00] rounded-full flex items-center justify-center shadow-xl border-4 border-black active:scale-95 transition-transform" data-id="element-36">
          <ScanLine size={28} className="text-black" data-id="element-37" />
        </button>
      </div>

      {/* Right Tabs */}
      <div className="flex justify-around flex-1" data-id="element-38">
        {rightTabs.map(tab => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => onNavigate(tab.id as ScreenName)} className={`flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-all ${isActive ? 'bg-[#FFFC00] text-black' : 'text-white'}`} data-id="element-39">
              <Icon size={20} className={isActive ? 'text-black' : 'text-white'} data-id="element-40" />
              <span className="text-xs mt-1 font-medium" data-id="element-41">{tab.label}</span>
            </button>;
      })}
      </div>
    </div>;
}